import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

  body {
    background: #E9E3DE;
    color: #111111;
    margin: 0 auto;
    padding: 0;
    max-width: 800px;
    padding-bottom: 100px;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
 }

  h1 {
    font: 400 36px/1.3 Helvetica, sans-serif;
    margin-bottom: 16px;
  }

  p {
    font: 400 20px/1.3 Helvetica, sans-serif;
    margin-bottom: 0;
  }

  a {
     text-decoration: none;
     color: #111111;
     transition: 0.3s all;
  }

  a:hover {
    color: #0077ff;
  }

  nav button {
    text-decoration: none;
    font: 400 16px/1.2 'Inter', sans-serif;
    color: #111;
    background: none;
    margin: 8px 4px;
    padding: 8px 12px;
    border-radius: 40px;
    border: none;
    cursor: pointer;
    transition: 0.3s all;
  }

  nav button:hover, nav button.active {
    background-color: #111;
    color: #d8d1cc;
  }

  main {
    background: #FFFFFF;
    padding: 20px;
    border-radius: 40px;
  }
 
  table {
    display: table;
    width: 100%;
  }

  tr {
    display: flex;
    justify-content: space-between;
    font: 400 18px/1.3 Helvetica, sans-serif;
  }
  
   td {
     margin-bottom: 4px;
   }

  @media (min-width: 600px) {

    h1 {
      font-size: 48px;
    }
`;
